module.exports = __webpack_public_path__ + "img/image_2-3fe2d09d.png";